import React, { useEffect, useRef } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const NonBenefit = () => {
  const applyAnimation = (animateRef) => {
    animateRef.current.style.opacity = "1";
    animateRef.current.style.animationDuration = "1.5s";
    animateRef.current.classList.add("animate__animated");
  };

  const animateRef1 = useRef();
  const animateRef2 = useRef();
  const animateRef3 = useRef();
  const animateRef4 = useRef();
  const animateRef5 = useRef();
  const animateRef6 = useRef();
  const animateRef7 = useRef();
  const animateRef8 = useRef();
  const animateRef9 = useRef();
  const animateRef10 = useRef();

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust this value based on when you want the animation to trigger
    };

    const handleIntersectionSlideInRight = (entries, observer, animateRef) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          applyAnimation(animateRef);
          animateRef.current.classList.add("animate__slideInRight");
          observer.unobserve(entry.target);
        }
      });
    };

    const handleIntersectionSlideInLeft = (entries, observer, animateRef) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          applyAnimation(animateRef);
          animateRef.current.classList.add("animate__slideInLeft");
          observer.unobserve(entry.target);
        }
      });
    };

    const observer1 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef1),
      options
    );
    if (animateRef1.current) {
      animateRef1.current.style.opacity = "0";
      observer1.observe(animateRef1.current);
    }

    const observer2 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef2),
      options
    );
    if (animateRef2.current) {
      animateRef2.current.style.opacity = "0";
      observer2.observe(animateRef2.current);
    }

    const observer3 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef3),
      options
    );
    if (animateRef3.current) {
      animateRef3.current.style.opacity = "0";
      observer3.observe(animateRef3.current);
    }

    const observer4 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInRight(entries, observer, animateRef4),
      options
    );
    if (animateRef4.current) {
      animateRef4.current.style.opacity = "0";
      observer4.observe(animateRef4.current);
    }

    const observer5 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef5),
      options
    );
    if (animateRef5.current) {
      animateRef5.current.style.opacity = "0";
      observer5.observe(animateRef5.current);
    }

    const observer6 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInRight(entries, observer, animateRef6),
      options
    );
    if (animateRef6.current) {
      animateRef6.current.style.opacity = "0";
      observer6.observe(animateRef6.current);
    }

    const observer7 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef7),
      options
    );
    if (animateRef7.current) {
      animateRef7.current.style.opacity = "0";
      observer7.observe(animateRef7.current);
    }

    const observer8 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInRight(entries, observer, animateRef8),
      options
    );
    if (animateRef8.current) {
      animateRef8.current.style.opacity = "0";
      observer8.observe(animateRef8.current);
    }

    const observer9 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef9),
      options
    );
    if (animateRef9.current) {
      animateRef9.current.style.opacity = "0";
      observer9.observe(animateRef9.current);
    }

    const observer10 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInRight(entries, observer, animateRef10),
      options
    );
    if (animateRef10.current) {
      animateRef10.current.style.opacity = "0";
      observer10.observe(animateRef10.current);
    }
    return () => {
      observer1.disconnect();
      observer2.disconnect();
      observer3.disconnect();
      observer4.disconnect();
      observer5.disconnect();
      observer6.disconnect();
      observer7.disconnect();
      observer8.disconnect();
      observer9.disconnect();
      observer10.disconnect();
    };
  }, []);

  return (
    <div className="wrap main_wrap">
      <Header />
      <div className="intro_wrap">
        <div className="clinic_banner_box">
          <div
            className="clinic_banner animate__animated animate__slideInRight"
            style={{ animationDuration: "1.2s" }}
          ></div>
          <div className="banner_text_box animate__animated" ref={animateRef1}>
            <div className="banner_title">키움성장소개</div>
            <div className="banner_text">비급여 고지</div>
          </div>
        </div>
        <div className="benefit_box">
          <div className="benefit_back">
            <div
              className="benefit_top_box animate__animated"
              ref={animateRef2}
            >
              <div className="benefit_title">
                *소아내분비 비급여 진료 사전 설명 안내
              </div>
              <div className="info_box">
                <div className="info_title">비급여란?</div>
                <div className="info_text">
                  건강보험 혜택이 적용되지 않아 환자가 전액 부담하는 비용으로,
                  의료기관이 자체적으로 금액을 정하여 의료기관마다 다를 수
                  있습니다. (건강보험 심사평가원)
                </div>
              </div>
            </div>
            <div className="benefit_bottom_box">
              <div className="benefit_row">
                <div
                  className="benefit_img_box animate__animated"
                  ref={animateRef3}
                >
                  <div className="benefit_img first"></div>
                </div>
                <div
                  className="benefit_text_box animate__animated"
                  ref={animateRef4}
                >
                  <div className="benefit_title">골연령 검사 8만원</div>
                  <div className="benefit_text">
                    골연령 및 키성장 검사는 "질환이 아닌" 개인의 성장의 상태를
                    평가하는 건강 검진으로 본인부담하는 비급여 검사입니다.
                    (2017년에 조사된 소아청소년성장도표에서 같은 연령, 같은
                    성별을 기준으로 키가 3백분위수를 넘어가는 경우에는 모두
                    비급여 검사에 해당합니다.)
                    <p className="benefit_inner_text">
                      *사춘기 발달이 궁금하여 진행하는 골연령 검사는
                      비급여입니다.
                    </p>
                  </div>
                </div>
              </div>
              <div className="benefit_row">
                <div
                  className="benefit_img_box animate__animated"
                  ref={animateRef5}
                >
                  <div className="benefit_img second"></div>
                </div>
                <div
                  className="benefit_text_box animate__animated"
                  ref={animateRef6}
                >
                  <div className="benefit_title">
                    사춘기 발달검사: 초음파 16만원, 혈액검사 20만원
                    (보험10만원내외)
                  </div>
                  <div className="benefit_text">
                    유방및사춘기 발달 초음파 검사: 질환이아닌 성성숙도
                    확인용으로 비보험이며 실비보험여부는 귀사에
                    문의부탁드립니다.
                    <p className="benefit_inner_text">
                      여아 만 8세 이후, 남아 만 9세 이후의 사춘기 발달검사는
                      비급여 검사입니다. 실비보험여부는 미리 확인부탁드립니다.
                      성장발달은 질환이 아니기때문에 ‘질병코드’가 발부되지
                      않습니다.
                    </p>
                  </div>
                </div>
              </div>
              <div className="benefit_row">
                <div
                  className="benefit_img_box animate__animated"
                  ref={animateRef7}
                >
                  <div className="benefit_img third"></div>
                </div>
                <div
                  className="benefit_text_box animate__animated"
                  ref={animateRef8}
                >
                  <div className="benefit_title">성장혈액검사 19-25만원</div>
                  <div className="benefit_text">
                    성장종합검사 :19만원(혈액검사만) 성장종합검사+ 성호르몬
                    검사(사춘기상태 확인) : 25만원
                    <p className="benefit_inner_text">
                      골연령판독및검사 불포함가격
                    </p>
                  </div>
                </div>
              </div>
              <div className="benefit_row">
                <div
                  className="benefit_img_box animate__animated"
                  ref={animateRef9}
                >
                  <div className="benefit_img fourth"></div>
                </div>
                <div
                  className="benefit_text_box animate__animated"
                  ref={animateRef10}
                >
                  <div className="benefit_title">성조숙증검사 보험기준</div>
                  <div className="benefit_text">
                    *현재 본원에서는 여아 만 7세 365일 이전, 남아 만 8세 365일
                    이전의 성조숙증검사는 의료 보험으로 진료를 받으실 수
                    있습니다. (가입하신 보험회사와 실손보험 대상이 되는
                    지를 사전에 확인하고 방문하셔야 합니다.)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NonBenefit;
